import {
  CREATE_DATA_COLLECTOR,
  CREATE_GENERAL_ORDER,
  CREATE_GENERAL_PH_SAMPLE,
  CREATE_REQUESTER,
  EMPTY_SAMPLE_LIST,
  FETCH_COLLECTED_SAMPLE,
  FETCH_GENERAL_APPROVED_SAMPLE,
  FETCH_GENERAL_COLLECTED_SAMPLE,
  FETCH_GENERAL_ORDER,
  FETCH_GENERAL_ORDERED_SAMPLE,
  FETCH_GENERAL_ORDER_TEST_TYPE,
  FETCH_PH_APPROVED_SAMPLE,
  FETCH_PH_COLLECTED_SAMPLE,
  FETCH_PH_WORKPLAN_SAMPLE,
  FETCH_SEARCHED_ENTERED_RESULT_LIST,
  FETCH_SEARCHED_PH_SAMPLE_LIST,
  FETCH_SEARCHED_PROGRAM_RESULT_LIST,
  FETCH_SEARCHED_SAMPLE_LIST,
  SET_GENERAL_APPROVED_PAGINATION,
  SET_GENERAL_COLLECTED_PAGINATION,
  SET_GENERAL_ORDER_PAGINATION,
  SET_GENERAL_PROGRAM_PAGINATION,
  SET_PH_COLLECTED_PAGINATION,
  SET_PH_WORKPLAN_PAGINATION,
} from "constants/ActionTypes";
import { pageSizeOptions } from "utils/Constant";

const INITIAL_STATE = {
  data: [],
  loading: false,
  generalOrderSampleList: [],
  publicOrderSampleList: [],
  generalPHSampleList: [],
  collectedSampleList: [],
  searchedSampleList: [],
  goSampleOrderedList: [],
  goSampleCollectedList: [],
  goSampleApprovedList: [],
  goSampleList: [],
  goSampleTestTypeList: [],
  pagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  phPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  collectedPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  approvedPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  phCollectedPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  phWorkplanPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  tbSample: null,
  phCollectedSampleList: [],
  phApprovedSampleList: [],
  phWorkplanSampleList: [],
  phApprovedSearchedSampleList: [],
  goSearchedResultList: [],
  collector: null,
  testRequester: null,
  programSearchResultList: [],
};

const OrderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_GENERAL_ORDER: {
      let updatedList = state.generalOrderSampleList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        generalOrderSampleList: updatedList,
      };
    }
    case CREATE_GENERAL_PH_SAMPLE: {
      let updatedList = state.generalPHSampleList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        generalPHSampleList: updatedList,
      };
    }
    case FETCH_SEARCHED_ENTERED_RESULT_LIST: {
      return {
        ...state,
        goSearchedResultList: action.payload,
      };
    }
    case FETCH_COLLECTED_SAMPLE: {
      return {
        ...state,
        collectedSampleList: action.payload,
      };
    }
    case FETCH_GENERAL_ORDER: {
      return {
        ...state,
        goSampleList: action.payload,
      };
    }
    case FETCH_GENERAL_ORDERED_SAMPLE: {
      return {
        ...state,
        goSampleOrderedList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_GENERAL_COLLECTED_SAMPLE: {
      return {
        ...state,
        goSampleCollectedList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_GENERAL_APPROVED_SAMPLE: {
      return {
        ...state,
        goSampleApprovedList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_GENERAL_ORDER_TEST_TYPE: {
      return {
        ...state,
        goSampleTestTypeList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_SEARCHED_SAMPLE_LIST: {
      return {
        ...state,
        searchedSampleList: action.payload,
      };
    }
    case EMPTY_SAMPLE_LIST: {
      return {
        ...state,
        searchedSampleList: [],
      };
    }
    case FETCH_PH_COLLECTED_SAMPLE: {
      return {
        ...state,
        phCollectedSampleList: action.payload,
      };
    }
    case FETCH_PH_APPROVED_SAMPLE: {
      return {
        ...state,
        phApprovedSampleList: action.payload,
      };
    }
    case FETCH_PH_WORKPLAN_SAMPLE: {
      return {
        ...state,
        phWorkplanSampleList: action.payload,
      };
    }
    case CREATE_DATA_COLLECTOR: {
      return {
        ...state,
        collector: action.payload,
      };
    }
    case CREATE_REQUESTER: {
      return {
        ...state,
        testRequester: action.payload,
      };
    }
    case FETCH_SEARCHED_PH_SAMPLE_LIST: {
      return {
        ...state,
        phApprovedSearchedSampleList: action.payload,
      };
    }
    case FETCH_SEARCHED_PROGRAM_RESULT_LIST: {
      return {
        ...state,
        programSearchResultList: action.payload,
      };
    }
    case SET_GENERAL_ORDER_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }
    case SET_GENERAL_PROGRAM_PAGINATION: {
      return {
        ...state,
        phPagination: action.payload,
      };
    }
    case SET_GENERAL_COLLECTED_PAGINATION: {
      return {
        ...state,
        collectedPagination: action.payload,
      };
    }
    case SET_GENERAL_APPROVED_PAGINATION: {
      return {
        ...state,
        approvedPagination: action.payload,
      };
    }
    case SET_PH_COLLECTED_PAGINATION: {
      return {
        ...state,
        phCollectedPagination: action.payload,
      };
    }
    case SET_PH_WORKPLAN_PAGINATION: {
      return {
        ...state,
        phWorkplanPagination: action.payload,
      };
    }
    default:
      return state;
  }
};

export default OrderReducer;
